import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import AddSubtaskFormContainer from "./AddSubtaskFormContainer.jsx";
import AddSubtaskTriggerContainer from "./AddSubtaskTriggerContainer.jsx";

const AddSubtask = ({ projectId, taskId, force, onCancel }) => {
  const [addNewSubtaskVisible, setAddNewSubtaskVisible] = useState(force);

  const showAddSubtaskForm = () => {
    setAddNewSubtaskVisible(true);
  };

  const hideAddSubtaskForm = useCallback(() => {
    setAddNewSubtaskVisible(false);
    if (typeof onCancel === `function`) {
      onCancel();
    }
  }, [onCancel]);

  return (
    <div
      className="new_subtask"
      id="new_subtask_form"
    >
      <AddSubtaskTriggerContainer
        handleOnClick={showAddSubtaskForm}
        visible={!addNewSubtaskVisible}
        classname="tw-my-0"
      />
      <AddSubtaskFormContainer
        visible={addNewSubtaskVisible}
        handleCancel={hideAddSubtaskForm}
        projectId={projectId}
        taskId={taskId}
      />
    </div>
  );
};

AddSubtask.propTypes = {
  projectId: PropTypes.number.isRequired,
  taskId: PropTypes.number.isRequired,
  onCancel: PropTypes.func,
  force: PropTypes.bool,
};

AddSubtask.defaultProps = {
  onCancel: () => {},
  force: false,
};

export default AddSubtask;
